<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('child_reports.monthly_resident_information_report') }}</h4>
        </template>
      <template v-slot:body>
        <b-row>
            <b-col lg="12" sm="12" md="12">
              <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
                <b-overlay :show="loadingState">
                <b-row>
                   <b-col lg="6" sm="12" md="4">
                                      <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="fiscal_year_id "
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                              {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.fiscal_year_id"
                                              id="fiscal_year_id"
                                              :options="fiscalYearList"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                                  {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                                  <b-col lg="6" sm="12">
                                      <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="organiation_id"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                  {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.org_id"
                                              :options="orgList"
                                              id="organiation_id"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                              {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                                  <b-col lg="6" sm="12">
                                      <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="office_type_id"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                  {{$t('legal_institute_management.institute_type')}} <span class="text-danger">*</span>
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.office_type_id"
                                              :options="officeTypeList"
                                              id="office_type_id"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                              {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                                  <b-col lg="6" sm="12">
                                      <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                                          <b-form-group
                                              class="row"
                                              label-cols-sm="4"
                                              label-for="office_id"
                                              slot-scope="{ valid, errors }"
                                              >
                                              <template v-slot:label>
                                                  {{$t('legal_institute_management.institute_name')}} <span class="text-danger">*</span>
                                              </template>
                                              <b-form-select
                                              plain
                                              v-model="search.office_id"
                                              :options="officeList"
                                              id="office_id"
                                              :state="errors[0] ? false : (valid ? true : null)"
                                              >
                                              <template v-slot:first>
                                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                              </template>
                                              </b-form-select>
                                              <div class="invalid-feedback">
                                              {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-col>
                        <b-col lg="6" sm="12">
                        <ValidationProvider name="Month" vid="month" rules="required|min_value:1">
                        <b-form-group
                         class="row"
                        label-cols-sm="4"
                        label-for="month"
                        >
                        <template v-slot:label>
                              {{$t('production_store.month')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                        plain
                        v-model="search.month"
                        :options="monthList"
                        id="month"
                        >
                      <template v-slot:first>
                       <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      </b-form-group>
                      </ValidationProvider>
                      </b-col>
                      <b-col sm="12" md="6">
                        <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                      </b-col>
                </b-row>
                </b-overlay>
                </b-form>
              </ValidationObserver>
                </b-col>
                  <!-- <b-col sm="12" md="6">
                      <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                  </b-col> -->
                       <!-- <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                      <b-button type="submit" variant="primary">{{ $t('globalTrans.report') }}</b-button>
                                  </b-col> -->
                </b-row>
                </template>
                </iq-card>
                <b-row>
                <b-col md="12">
                <iq-card>
                <template v-slot:body>
                 <b-row v-if="loaded">
                    <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                        <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                            <h3 class="text-bold">{{ $t('production_store.govt_info') }}</h3>
                            <h4 class="text-center text-dark">{{ reportHeadData.orgName }}</h4>
                            <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
                            <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
                            <div class="titleDiv">
                              <span class="text-center text-dark reportTitle" style="font-weight:bold;">{{ $t('child_reports.monthly_resident_information_report') }}</span><br>
                            </div>
                    </b-col>
                    <b-col xs="12" sm="12" md="3" class="mt-4 text-right">
                        <b-button-group>
                            <b-button @click="pdfExport" variant="success" class="mr-2">{{  $t('globalTrans.export_pdf') }}</b-button>
                            <b-button variant="warning">
                              <export-excel
                                worksheet="Report Sheet"
                                :title=headerValue
                                :data=excelData
                                name="monthly-resident-information-report.xls">
                                {{ $t('globalTrans.export_excel') }}
                              </export-excel>
                            </b-button>
                        </b-button-group>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" class="mt-4 mb-1">
                      <b-row>
                        <b-col xs="12" sm="12" md="6" class="text-left">
                            <div v-if="titleData.org_name" class="text-dark"><b>{{ $t('globalTrans.organization') }} </b>: {{ titleData.org_name }}</div>
                            <span v-if="titleData.institute_type_name" class="text-center text-dark"><b>{{ $t('child_configuration.institute_type') }} </b>: {{ titleData.institute_type_name }}</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" class="text-right">
                            <div v-if="titleData.institute_name" class="text-dark"><b>{{ $t('child_configuration.institute_name') }} </b>: {{ titleData.institute_name }}</div>
                            <span v-if="titleData.year" class="text-center text-dark"><b>{{ $t('globalTrans.fiscal_year') }} </b>: {{ titleData.year }}</span>
                        </b-col>
                      </b-row>
                    </b-col>
                </b-row>
                 <b-overlay :show="loadingState">
                    <b-row>
                        <!-- <b-col lg="12" xs="12" md="12"> -->
                            <b-table-simple responsive="true" bordered style="width: 100%; font-size:11px">
                                <b-thead>
                                    <b-tr class="bg-none">
                                        <!-- <b-th rowspan="2" style="vertical-align: middle">{{ $t('globalTrans.sl_no') }}</b-th> -->
                                        <b-th style="vertical-align: top">{{ $t('globalTrans.sl_no') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.institute_name_address') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.approved_seats') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.no_residents') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.residents_admitted') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.total_resident') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.total_rehabilitation_month') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.total_release_month') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.total_residents_month') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.total_rehabilitated_residents_admission') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.total_rehabilitated_residents') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.total_release_residents') }}</b-th>
                                        <b-th style="vertical-align: top">{{ $t('child_reports.Comments') }}</b-th>
                                    </b-tr>
                                </b-thead>
                                <b-tbody>
                                    <b-tr style="font-weight: bold;">
                                        <b-td class="text-center">{{ $n(1) }}</b-td>
                                        <b-td class="text-center">{{ $n(2) }}</b-td>
                                        <b-td class="text-center">{{ $n(3) }}</b-td>
                                        <b-td class="text-center">{{ $n(4) }}</b-td>
                                        <b-td class="text-center">{{ $n(5) }}</b-td>
                                        <b-td class="text-center">{{ $n(4) }}+{{ $n(5) }}={{ $n(6) }}</b-td>
                                        <b-td class="text-center">{{ $n(7) }}</b-td>
                                        <b-td class="text-center">{{ $n(8) }}</b-td>
                                        <b-td class="text-center">{{ $n(6) }}-({{ $n(7) }}+{{ $n(8) }})={{ $n(9) }}</b-td>
                                        <b-td class="text-center">{{ $n(10) }}</b-td>
                                        <b-td class="text-center">{{ $n(11) }}</b-td>
                                        <b-td class="text-center">{{ $n(12) }}</b-td>
                                        <b-td class="text-center">{{ $n(13) }}</b-td>
                                    </b-tr>
                                    <b-tr v-if="report_data.office_id">
                                      <b-td class="text-center">{{ $n(1) }}</b-td>
                                      <b-td>{{ titleData.institute_name }}</b-td>
                                      <b-td>{{ $n(report_data.approved_seats) }}</b-td>
                                      <b-td>{{ $n(report_data.no_residents) }}</b-td>
                                      <b-td>{{ $n(report_data.residents_admitted) }}</b-td>
                                       <b-th>{{ $n(report_data.no_residents+report_data.residents_admitted) }}</b-th>
                                      <b-td>{{ $n(report_data.total_release_month) }}</b-td>
                                      <b-td>{{ $n(report_data.total_rehabilitation_month) }}</b-td>
                                      <b-th>{{ $n(report_data.no_residents+report_data.residents_admitted-report_data.total_rehabilitation_month-report_data.total_release_month) }}</b-th>
                                      <b-td>{{ $n(report_data.total_rehabilitated_residents_admission) }}</b-td>
                                      <b-td>{{ $n(report_data.total_rehabilitated_residents) }}</b-td>
                                      <b-td>{{ $n(report_data.total_release_residents) }}</b-td>
                                      <b-td>{{ report_data.Comments }}</b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                    </b-row>
                </b-overlay>
            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { residentInformationReportListApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import ExportPdf from './export-pdf_details'
import ReportHeading from '@/Utils/report-head'
import excel from 'vue-excel-export'
import ExportExcel from './export-excel'
import Vue from 'vue'
Vue.use(excel)

export default {
  mixins: [RouteBasedList],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        org_id: 0,
         month: 0,
        office_type_id: 0,
        office_id: 0
      },
      titleData: {
        year: '',
        org_name: '',
        institute_type_name: '',
        institute_name: ''
      },
      report_data: {
          institute_name: '',
          approved_seats: '',
          no_residents: '',
          residents_admitted: '',
          total_resident: '',
          total_rehabilitation_month: '',
          total_release_month: '',
          total_residents_month: '',
          total_rehabilitated_residents_admission: '',
          total_rehabilitated_residents: '',
          total_release_residents: '',
          Comments: ''
      },
      editItemId: 0,
      officeTypeList: [],
      officeList: [],
      rows: [],
      reportHeadData: '',
      loaded: false,
      items: []
    }
  },
  computed: {
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
     monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    excelData: function () {
      return ExportExcel.excelBody(this)
    },
    headerValue: function () {
      const title = this.$t('child_reports.monthly_resident_information_report')
      return ExportExcel.headerData(title)
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('child_reports.institute_name_address'), class: 'text-left' },
          { label: this.$t('child_reports.approved_seats'), class: 'text-left' },
          { label: this.$t('child_reports.no_residents'), class: 'text-left' },
          { label: this.$t('child_reports.residents_admitted'), class: 'text-left' },
          { label: this.$t('child_reports.total_resident'), class: 'text-left' },
          { label: this.$t('child_reports.total_rehabilitation_residents'), class: 'text-left' },
          { label: this.$t('child_reports.total_residents_month'), class: 'text-left' },
          { label: this.$t('child_reports.total_rehabilitated_residents_admission'), class: 'text-left' },
          { label: this.$t('child_reports.total_rehabilitated_residents'), class: 'text-left' },
          { label: this.$t('child_reports.Comments'), class: 'text-left' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'institute_name' },
          { key: 'office_code' },
          { key: 'name_bn' },
          { key: 'father_name_bn' },
          { key: 'mother_name_bn' },
          { key: 'registration_id' },
          { key: 'age' },
          { key: 'custom_address' },
          { key: 'legal_guardian_bn' },
          { key: 'profession_income' },
          { key: 'rel_with_guardian_bn' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'institute_name' },
          { key: 'office_code' },
          { key: 'name' },
          { key: 'father_name' },
          { key: 'mother_name' },
          { key: 'registration_id' },
          { key: 'age' },
          { key: 'custom_address' },
          { key: 'legal_guardian' },
          { key: 'profession_income' },
          { key: 'rel_with_guardian' }
        ]
      }

      return labels.map((item, index) => {
        return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeTypeList()
       this.getOrgName()
      } else {
        this.titleData.org_name = ''
      }
    },
    'search.office_type_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeList()
       this.getOfficeTypeName()
      } else {
        this.titleData.institute_type_name = ''
      }
    },
    'search.office_id': function (newVal, oldVal) {
      if (newVal !== 0) {
       this.getOfficeName()
      } else {
        this.titleData.institute_name = ''
      }
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
      if (newVal !== 0) {
        this.getFiscalYear()
        this.report_data = []
      } else {
          this.titleData.year = ''
          this.report_data = []
      }
    },
    currentLocale: function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (this.search.org_id) {
                this.getOfficeTypeList()
                this.getOrgName()
            }
            if (this.search.office_type_id) {
                this.getOfficeList()
                this.getOfficeTypeName()
            }
            if (this.search.office_id) {
                this.getOfficeName()
            }
            if (this.search.fiscal_year_id) {
              this.getFiscalYear()
            }
            this.headerName()
        }
    }
  },
  created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
    this.headerName()
  },
  mounted () {
  },
  methods: {
    details (item) {
      this.editItemId = item.id
    },
     getMonthName (mId) {
      const monthId = parseInt(mId)
      const monthObj = this.monthList.find(item => item.value === monthId)
      return monthObj.text
    },
    getFiscalYear () {
        const Year = this.$store.state.commonObj.fiscalYearList.find(item => item.value === this.search.fiscal_year_id)
        if (this.$i18n.locale === 'bn') {
            this.titleData.year = Year.text_bn
        } else {
            this.titleData.year = Year.text_en
        }
    },
    searchData () {
      this.loadData()
    },
    getOrgName () {
      const Org = this.$store.state.commonObj.organizationProfileList.find(item => item.status === 0 && item.value === this.search.org_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.org_name = Org.text_bn
      } else {
          this.titleData.org_name = Org.text_en
      }
    },
    getOfficeTypeName () {
      const Org = this.$store.state.commonObj.officeTypeList.find(item => item.status === 0 && item.value === this.search.office_type_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_type_name = Org.text_bn
      } else {
          this.titleData.institute_type_name = Org.text_en
      }
    },
    getOfficeName () {
      const Org = this.$store.state.commonObj.officeList.find(item => item.status === 0 && item.value === this.search.office_id)
      if (this.$i18n.locale === 'bn') {
          this.titleData.institute_name = Org.text_bn
      } else {
          this.titleData.institute_name = Org.text_en
      }
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      const params = Object.assign({}, this.search)
      RestApi.getData(childServiceBaseUrl, residentInformationReportListApi, params).then(response => {
        if (response.success) {
            this.report_data = response.data
            // this.$store.dispatch('setList', this.getRelationalData(response.data))
            // this.paginationData(response.data)
        }
        this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
      let tmpFiscalYear = {}
      let tmpInstitute = {}
      let tmpDistrict = {}
      let tmpUpazila = {}
      let tmpCityCorporation = {}
      let tmpUnion = {}
      let tmpPaurashaba = {}
      let tmpWard = {}
      const listData = data.map(item => {
          tmpFiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscal => fiscal.value === item.fiscal_year_id && fiscal.status === 0)
          tmpInstitute = this.$store.state.commonObj.officeList.find(office => office.value === item.office_id && office.status === 0)
          tmpDistrict = this.$store.state.commonObj.districtList.find(district => district.value === item.pre_district_id && district.status === 0)
          tmpUpazila = this.$store.state.commonObj.upazilaList.find(upazila => upazila.value === item.pre_upazila_id && upazila.status === 0)
          tmpCityCorporation = this.$store.state.commonObj.cityCorporationList.find(city => city.value === item.pre_city_corporation_id && city.status === 0)
          tmpUnion = this.$store.state.commonObj.unionList.find(union => union.value === item.pre_union_id && union.status === 0)
          tmpPaurashaba = this.$store.state.commonObj.pauroshobaList.find(pauroshoba => pauroshoba.value === item.pre_paurasabha_id && pauroshoba.status === 0)
          tmpWard = this.$store.state.commonObj.wardList.find(ward => ward.value === item.pre_ward_id && ward.status === 0)
          const admissionData = {
              fiscal_year: tmpFiscalYear !== undefined ? tmpFiscalYear.text_en : '',
              fiscal_year_bn: tmpFiscalYear !== undefined ? tmpFiscalYear.text_bn : '',
              institute_name: tmpInstitute !== undefined ? tmpInstitute.text_en : '',
              institute_name_bn: tmpInstitute !== undefined ? tmpInstitute.text_bn : '',
              district_name: tmpDistrict !== undefined ? tmpDistrict.text_en : '',
              district_name_bn: tmpDistrict !== undefined ? tmpDistrict.text_bn : '',
              upazila_name: tmpUpazila !== undefined ? tmpUpazila.text_en : '',
              upazila_name_bn: tmpUpazila !== undefined ? tmpUpazila.text_bn : '',
              city_corp_name: tmpCityCorporation !== undefined ? tmpCityCorporation.text_en : '',
              city_corp_name_bn: tmpCityCorporation !== undefined ? tmpCityCorporation.text_bn : '',
              union_name: tmpUnion !== undefined ? tmpUnion.text_en : '',
              union_name_bn: tmpUnion !== undefined ? tmpUnion.text_bn : '',
              pauroshoba_name: tmpPaurashaba !== undefined ? tmpPaurashaba.text_en : '',
              pauroshoba_name_bn: tmpPaurashaba !== undefined ? tmpPaurashaba.text_bn : '',
              ward_name: tmpWard !== undefined ? tmpWard.text_en : '',
              ward_name_bn: tmpWard !== undefined ? tmpWard.text_bn : ''
          }
          return Object.assign({}, item, admissionData)
      })
      return listData
    },
    async headerName () {
       const headdata = await ReportHeading.getReportHead(childServiceBaseUrl, 'configuration/report-heading/detail', 2)
       this.reportHeadData = headdata
       this.loaded = true
    },
   pdfExport () {
      const reportTitle = this.$t('child_reports.monthly_resident_information_report')
      ExportPdf.exportPdfDetails(childServiceBaseUrl, 'configuration/report-heading/detail', 2, reportTitle, this.report_data, this, this.titleData)
    }
  }
}
</script>
<style scoped>
.reportTitle {
  font-weight: bold;
    border: 1px solid;
    padding: 8px 15px 8px 15px;
    border-radius: 11px;
}
.titleDiv {
  margin-top: 1.2rem;
  font-size: 18px;
}
</style>
